import React from "react";
import { NavLink } from "react-router-dom";

import { urls } from "../../utils";

export const NavBarLinks = ({
  hideRoot = false,
  isMobile = false,
  toggleFunction = () => {},
}) => {
  const outerDivClasses = isMobile
    ? "mobile__menu col-12"
    : "navbar__container__chapters flex flex-row col-12 justify-around";
  const linkClasses = isMobile
    ? "flex-row fade-in center h0 hover-bold capitalize"
    : "hover-bold mr1 p2 capitalize";

  return (
    <div className={outerDivClasses}>
      {!hideRoot && (
        <NavLink
          key={`nav-item-home`}
          className={linkClasses}
          to={urls.root.path}
          onClick={toggleFunction}
          data-label="Home"
        >
          Home
        </NavLink>
      )}
      {Object.values(urls)
        .filter((u) => u.inNavBar)
        .map((url) => (
          <NavLink
            key={`nav-item-${url.text}`}
            isActive={url.isActive}
            to={url.path}
            smooth={null}
            activeClassName="matched"
            className={linkClasses}
            onClick={toggleFunction}
            data-label={url.text}
          >
            {url.text}
          </NavLink>
        ))}
    </div>
  );
};
